// extracted by mini-css-extract-plugin
module.exports = {"page":"admin-ui-v2_page__Zz7tF","legacyShell":"admin-ui-v2_legacyShell__1Zhl-","modernShell":"admin-ui-v2_modernShell__ax3Xh"};